import { Capacitor } from "@capacitor/core";

/**
 * Handle file downloads across different platforms
 *
 * - On iOS/Android: Opens URL in external browser where downloads work
 * - On Web: Uses traditional download approach with anchor element
 *
 * @param url - The URL to download from
 * @param filename - The filename to use for the download (web only)
 */
export async function downloadFile(url: string, filename: string) {
  if (Capacitor.isNativePlatform()) {
    // On iOS/Android, we need to open in an external browser
    // Using location.href as it's more reliable than window.open on iOS WebView
    window.location.href = url;
  } else {
    // On web, use the traditional download approach
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.target = "_blank";
    link.rel = "noopener noreferrer";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Fallback for older browsers
    setTimeout(() => {
      if (!document.hasFocus()) {
        window.location.href = url;
      }
    }, 100);
  }
}
